import React from 'react';
import BaseIconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

import { BUTTON_COLOR, BUTTON_TYPE } from '../../enum/formProps';

interface IconButtonProps {
  icon: IconDefinition;
  type?: BUTTON_TYPE;
  color?: BUTTON_COLOR;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

const IconButton: React.FC<IconButtonProps> = (props) => {
  return (
    <BaseIconButton
      onClick={props.onClick}
      color={props.color}
      type={props.type}
      disabled={props.disabled}
      className={props.className}
    >
      <FontAwesomeIcon icon={props.icon} />
    </BaseIconButton>
  );
};

export default IconButton;
